export default "__VITE_ASSET__DL9ggZ$5__"